import React from 'react';

const SettingsTrade = (props: { active: boolean }) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.6094 12.9219H2.51562V1.95312C2.51562 1.87578 2.45234 1.8125 2.375 1.8125H1.39062C1.31328 1.8125 1.25 1.87578 1.25 1.95312V14.0469C1.25 14.1242 1.31328 14.1875 1.39062 14.1875H14.6094C14.6867 14.1875 14.75 14.1242 14.75 14.0469V13.0625C14.75 12.9852 14.6867 12.9219 14.6094 12.9219ZM4.37539 10.2096C4.42988 10.2641 4.51777 10.2641 4.57402 10.2096L7.00508 7.79082L9.24805 10.0479C9.30254 10.1023 9.39219 10.1023 9.44668 10.0479L14.2877 5.20859C14.3422 5.1541 14.3422 5.06445 14.2877 5.00996L13.5916 4.31387C13.5652 4.2877 13.5295 4.27302 13.4923 4.27302C13.4551 4.27302 13.4194 4.2877 13.393 4.31387L9.35 8.35508L7.11055 6.10156C7.08412 6.07539 7.04843 6.06071 7.01123 6.06071C6.97404 6.06071 6.93834 6.07539 6.91191 6.10156L3.68105 9.31309C3.65488 9.33952 3.6402 9.37521 3.6402 9.4124C3.6402 9.4496 3.65488 9.48529 3.68105 9.51172L4.37539 10.2096Z"
				fill={props.active ? 'url(#icon-gradient)' : '#6683A7'}
			/>
		</svg>
	);
};

export default SettingsTrade;
